import React from 'react';
import Dropdown from '@/components/atoms/Dropdown/Dropdown';
import './DropdownFilter.scss';

/**
 * DropdownFilter - A specialized dropdown component for data table filters
 * 
 * @param {Object} props - The properties object
 * @param {string} props.value - Current filter value
 * @param {Function} props.onChange - Function to handle value changes
 * @param {Array} props.options - Array of dropdown options
 * @param {string} props.placeholder - Placeholder text for the dropdown
 * @param {string} props.className - Additional CSS classes
 * @param {Object} props.style - Inline styles
 * @param {string} props.columnName - Name of the database column
 * @returns {JSX.Element} The rendered DropdownFilter component
 */
const DropdownFilter = ({
  value = '',
  onChange = () => {},
  options = [],
  placeholder = 'Select option',
  className = '',
  style = {},
  columnName = '',
}) => {
  // Format the current value for the dropdown component
  const selectedOption = value ? [{ id: value, displayText: value }] : [];
  
  // Handle dropdown value changes
  const handleValueChange = (selectedValue) => {
    const selectedId = selectedValue?.[0]?.id || '';
    const event = {
      target: {
        name: columnName,
        value: selectedId
      }
    };
    onChange(event);
  };

  return (
    <div className={`dropdown-filter-wrapper ${className}`} style={style}>
      <Dropdown
        value={selectedOption}
        updateValue={handleValueChange}
        schema={{
          options: options,
        }}
        uiSchema={{
          placeholder: placeholder,
          selection: 'single',
          size: 'small',
          isDark: true,
          className: 'dropdown-filter-input'
        }}
        isClearable={false}
        isJsonWrap={true}
      />
    </div>
  );
};

export default DropdownFilter;
